import {getGroupJackpot} from '../api/getGroupJackpot';
import {setGetGroupJackpotAction} from '../action';

const setGetGroupJackpot = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGroupJackpot(params);
     
            if (data.status === 'success') {
                dispatch(setGetGroupJackpotAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetGroupJackpot
}